import api from "./api"

export const getKpiMetricAPI = async ({ sido, kapt_code, ended_at }) => {
  const { data } = await api.get("/api/usage/kpi", {
    params: { sido, kapt_code, ended_at }
  })
  return data
}

export const getResourceTrendAPI = async ({ sido, kapt_code, period, ended_at }) => {
  const { data } = await api.get("/api/usage/trend", {
    params: { sido, kapt_code, period, ended_at }
  })
  return data
}

export const getTopUsageRankAPI = async ({ sido, kapt_code, ended_at }) => {
  const { data } = await api.get("/api/usage/top-rank", {
    params: { sido, kapt_code, ended_at }
  })
  return data
}

export const getStatsDataAPI = async ({ sido, kapt_code, start_date, end_date, resource }) => {
  const { data } = await api.get("/api/usage/statistics", {
    params: { sido, kapt_code, start_date, end_date, resource }
  })
  return data
}

export const getUsageSummaryAPI = async ({
  sido,
  kapt_code,
  dong,
  ho,
  resource = "water",
  start_date,
  end_date,
  scope = "apt"
}) => {
  const { data } = await api.get("/api/usage/summary", {
    params: {
      sido,
      kapt_code,
      dong,
      ho,
      resource,
      start_date,
      end_date,
      scope
    }
  })
  return data
}

export const getUsageRawAPI = async ({
  sido,
  kapt_code,
  dong,
  ho,
  start_date,
  end_date,
  resource
}) => {
  const { data } = await api.get("/api/usage/raw", {
    params: {
      sido,
      kapt_code,
      dong,
      ho,
      start_date,
      end_date,
      resource
    }
  })
  return data
}

export const getWeekdayCompareAPI = async ({
  sido,
  kapt_code,
  dong,
  ho,
  target_date,
  resource = "water"
}) => {
  const { data } = await api.get("/api/usage/weekday/compare", {
    params: {
      sido,
      kapt_code,
      dong,
      ho,
      target_date,
      resource
    }
  })

  return data
}

export const getWeekdayDetailAPI = async ({
  sido,
  kapt_code,
  dong,
  ho,
  target_date,
  resource = "water"
}) => {
  const { data } = await api.get("/api/usage/weekday/detail", {
    params: {
      sido,
      kapt_code,
      dong,
      ho,
      target_date,
      resource
    }
  })

  return data
}

export const getPatternClockAPI = async ({
  sido,
  kapt_code,
  dong,
  ho,
  target_date,
  resource = "water"
}) => {
  const { data } = await api.get("/api/usage/pattern-clock", {
    params: {
      sido,
      kapt_code,
      dong,
      ho,
      target_date,
      resource
    }
  })
  return data
}
